import { z } from "zod";

import { zNoEmptyObject } from "../../utils";
import { ErrorResponse, SuccessResponse } from "./standard-responses";

export const hqEndpoints = {
  "hq.teams.adjustLicenses": (p: { teamId: string }) => ["hq", "post", `/teams/${p.teamId}/adjust_licenses`],
} as const satisfies Record<string, (p: any) => ["hq", "get" | "delete" | "post" | "put", `/${string}`]>;

export const hqRequests = {
  "hq.teams.adjustLicenses": z.object({
    teamId: z.custom<`t_${string}`>(),
  }),
  "hq.teams.update.vat": z.object({
    teamId: z.custom<`t_${string}`>(),
    vatNumber: z.string().optional().nullable(),
  }),
} as const;

export const hqResponses = {
  "hq.teams.adjustLicenses": SuccessResponse,
  "hq.teams.update.vat": SuccessResponse.or(
    ErrorResponse.extend({
      error: z.literal("validation_error"),
      teamErrors: zNoEmptyObject(z.object({ vatNumber: z.string() })),
    }),
  ),
} as const;
